module.exports = __webpack_public_path__ + "static/media/female-active.6b8b2ada.svg";